import { DialogTitle } from '@radix-ui/react-dialog';
import { DialogHeader } from '../../utils/components/ui/dialog';
import { Button } from '../../utils/components/ui/button';
import { ErrorWraper } from '../common/ErrorWrapper';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useInfiniteGetAllPurchase } from '../../service/purchaseService';
import { ReusableCombobox } from '../../utils/components/ui/combobox';
import { useState } from 'react';

interface Props {
  setOpen: (open: boolean) => void;
  onContinue?: (invoiceNumber: string) => void;
}

function AddNewPurchaseReturn({ setOpen, onContinue }: Props) {
  const navigate = useNavigate();
  const [selectedInvoice, setSelectedInvoice] = useState('');
  const [comboboxOpen, setComboboxOpen] = useState(false);
  const [searchKey, setSearchKey] = useState(''); // <-- Add this

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setError,
    setValue,
  } = useForm<{ invoiceNumber: string }>({
    defaultValues: {
      invoiceNumber: '',
    },
  });

  const { data } = useInfiniteGetAllPurchase({
    pageSize: 10,
    pageNo: 0,
    purchaseNumber: searchKey, // <-- Use searchKey here
  });

  const handleCancel = () => {
    setOpen(false);
    reset();
    setSelectedInvoice(''); // Reset state
  };

  const handleContinue = (data: { invoiceNumber: string }) => {
    const purchase = purchaseData.find(item => String(item.id) === data.invoiceNumber);
    if (!purchase?.vendorId) {
      setError('invoiceNumber', { message: 'Select an invoice with a valid vendor.' });
      return;
    }
    if (onContinue) onContinue(purchase.purchaseNumber);
    navigate(`/purchase-return/${encodeURIComponent(purchase.purchaseNumber)}?vendorId=${purchase.vendorId}`);
    setOpen(false);
    reset();
    setSelectedInvoice(''); // Reset state
  };

  const purchaseData = data?.pages[0]?.purchaseEntryResponseList || [];

  return (
    <div className="space-y-4">
      <DialogHeader>
        <DialogTitle className="text-[#1A5EF9] text-xl font-medium">
          Purchase Return
        </DialogTitle>
      </DialogHeader>
      <form onSubmit={handleSubmit(handleContinue)} className="space-y-4">
        <div>
          <label className="text-[#1A5EF9] text-sm mb-1 block">
            Enter Purchase Number
          </label>
          <ErrorWraper message={errors.invoiceNumber?.message}>
            {/* Hidden input for form validation */}
            <input
              type="hidden"
              {...register('invoiceNumber', {
                required: 'Invoice number is required',
              })}
            />
            <ReusableCombobox
              options={
                purchaseData.map(purchase => ({
                  value: String(purchase.id),
                  label: `${purchase.purchaseNumber} — ${purchase.vendorName}`,
                })) || []
              }
              value={selectedInvoice}
              onValueChange={value => {
                setSelectedInvoice(value as string);
                setValue('invoiceNumber', value as string); // Update form value
                setComboboxOpen(false); // Close combobox on select
              }}
              open={comboboxOpen}
              setOpen={setComboboxOpen}
              placeholder="Invoice Number"
              searchPlaceholder="Search invoice..."
              emptyText="No invoices found."
              className="w-full bg-[#F3F4F3] rounded border border-[#BAC4C0] h-10"
              // Pass search handler to combobox
              onInputChange={val => setSearchKey(val)}
            />
          </ErrorWraper>
        </div>
        <div className="flex justify-end gap-3 pt-4">
          <Button
            type="button"
            variant="outline"
            className="border-[#BAC4C0] text-[#84928C] hover:bg-gray-50 px-6 py-2"
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            className="bg-[#1A5EF9] hover:bg-[#1450D1] text-white px-6 py-2"
          >
            Continue
          </Button>
        </div>
      </form>
    </div>
  );
}

export default AddNewPurchaseReturn;
